import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateModules } from "../../actions";
import {
  OsnTextarea,
  Button,
  OsnInputText,
} from "@identitybuilding/idb-react-ui-elements";
import axios from "axios";
import Quote from "@identitybuilding/idb-react-quote/dist/Quote";

const ReviewEdit = (props) => {
  const dispatch = useDispatch();

  let modules = useSelector((state) => state.AdminReducer.modules);
  let data = useSelector((state) => state.AdminReducer.data);

  let [quoteTitle, setQuoteTitle] = useState(data.options.quote.title);
  let entityCopy = Object.assign({}, data);
  let modulcesCopy = [...modules];

  const handler = (action, keyword) => {
    if (action === "template") {
      entityCopy.options.quote.template = keyword;
      adminChange(keyword, action);
    }
    if (action === "title") {
      entityCopy.options.quote.title = keyword;
      adminChange(keyword, action);
    }
    if (action === "theme") {
      entityCopy.options.quote.theme = keyword;
      adminChange(keyword, action);
    }

    modulcesCopy[props.index].module = (
      <Quote
        template={entityCopy.options.quote.template}
        theme={entityCopy.options.quote.theme}
        quotes={entityCopy.options.quote.quotes}
        title={entityCopy.options.quote.title}
      />
    );
    dispatch(updateModules(modulcesCopy));
    // setModules(modulcesCopy);
  };
  const adminChange = (props, action) => {
    axios
      .put(
        `https://onepage-78a00-default-rtdb.europe-west1.firebasedatabase.app/data/data/options/quote.json`,
        {
          [action]: props,
          ...entityCopy.options.quote,
        }
      )
      .then(async (resp) => {
      });
  };

  return (
    <div className="testBlock">
      <div className="testTitle">Quote</div>
      <div>
        <span>Title:</span>
        <OsnInputText
          onChange={(e) => setQuoteTitle(e.target.value)}
          value={quoteTitle}
          placeholder={quoteTitle}
        />
        <Button
          bgColor={["cn"]}
          size="S"
          text="Change title"
          txtColor="white"
          type="main"
          onClick={() => handler("title", quoteTitle)}
        />
      </div>
      <div>
        <span>Template:</span>
        <ul>
          <li onClick={() => handler("template", 1)}>1</li>
          <li onClick={() => handler("template", 2)}>2</li>
        </ul>
      </div>
      <div>
        <span>Theme:</span>
        <ul>
          <li onClick={() => handler("theme", "dark")}>dark</li>
          <li onClick={() => handler("theme", "light")}>light</li>
        </ul>
      </div>
    </div>
  );
};

export default ReviewEdit;
